<template>
	<div
		class="tw3-rounded-2xl tw3-border tw3-border-surface-200 tw3-bg-surface-0 tw3-shadow-sm"
	>
		<slot />
	</div>
</template>
